import { useState, useEffect } from 'react';
import '../../index.css';
import apiService from '../../services/api.services';
import Navbar from '../../components/common/Navbar';
import '../../css/adminpage.css';
import { Row, Col, Container, Button, Form, InputGroup } from 'react-bootstrap';
import { MDBTable, MDBTableHead, MDBTableBody, MDBBadge, MDBContainer, MDBBtn } from 'mdb-react-ui-kit';
import { MDBModal, MDBModalDialog, MDBModalContent, MDBModalHeader, MDBModalTitle, MDBModalBody, MDBModalFooter } from 'mdb-react-ui-kit';
import { toast } from 'react-toastify';


function Admin() {

    useEffect(() => {
        const JWTtoken = window.sessionStorage.getItem('token')
        apiService.getAllUserWithRoles(JWTtoken)
            .then(response => {
                setAllRows(response.data.users);
            })
            .catch(error => {
                setError(error);
            });
        apiService.getAllUser(JWTtoken)
            .then(response => {
                setUserData(response.data.users);
            })
            .catch(error => {
                setError(error);
            });
        apiService.getAllRoles(JWTtoken)
            .then(response => {
                // setRolesData(response.data.users);
                setRolesData(response.data.roles);
            })
            .catch(error => {
                setError(error);
            });
    }, []);

    

    // Data
    const [allRows, setAllRows] = useState([]);
    const [error, setError] = useState(null);

    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 10; // Number of rows per page

    const [filteredRows, setFilteredRows] = useState([]);
    // Calculate total pages
    const totalPages = Math.ceil(allRows.length / rowsPerPage);

    // Calculate the rows to display on the current page
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    // const currentRows = allRows.slice(indexOfFirstRow, indexOfLastRow);
    const currentRows = filteredRows.slice(indexOfFirstRow, indexOfLastRow);


    const pageGroupSize = 5;
    const currentGroup = Math.floor((currentPage - 1) / pageGroupSize);
    const startPage = currentGroup * pageGroupSize + 1;
    const endPage = Math.min(startPage + pageGroupSize - 1, totalPages);

    // Handle page change
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    //----------------------------------------------------------------------- 

    const [centredModal, setCentredModal] = useState(false);
    const toggleOpen = () => setCentredModal(!centredModal);
    const [userData, setUserData] = useState([]);
    const [searchEmpId, setSearchEmpId] = useState('');
    const [showDropdown1, setShowDropdown1] = useState(false);

    const [searchTeamleader, setSearchTeamleader] = useState('');
    const [showDropdown3, setShowDropdown3] = useState(false);

    const [searchBranchHead, setSearchBranchHead] = useState('');
    const [showDropdown4, setShowDropdown4] = useState(false);

    const [searchExportCompliance, setSearchExportCompliance] = useState('');
    const [showDropdown5, setShowDropdown5] = useState(false);

    const [searchRegionBusinessHead, setSearchRegionBusinessHead] = useState('');
    const [showDropdown6, setShowDropdown6] = useState(false);

    const [searchCreditInsurance, setSearchCreditInsurance] = useState('');
    const [showDropdown7, setShowDropdown7] = useState(false);

    const [searchBusinessFinance, setSearchBusinessFinance] = useState('');
    const [showDropdown8, setShowDropdown8] = useState(false);

    // const [searchCFO, setSearchCFO] = useState('');
    // const [showDropdown9, setShowDropdown9] = useState(false);

    // const [searchCOO, setSearchCOO] = useState('');
    // const [showDropdown10, setShowDropdown10] = useState(false);

    // const [searchCEO, setSearchCEO] = useState('');
    // const [showDropdown11, setShowDropdown11] = useState(false);

    // const [searchSvpDirector, setSearchSvpDirector] = useState('');
    // const [showDropdown12, setShowDropdown12] = useState(false);



    const [roles, setRolesData] = useState([]);
    const [searchRole, setSearchRole] = useState('');
    const [showDropdown2, setShowDropdown2] = useState(false);
    const [loading, setLoading] = useState(false);
    const [newRole, setNewRole] = useState('');
    const [assignUserId, setAssignUserId] = useState();
    const [assignUserName, setAssignUserName] = useState();
    const [assignEmailId, setAssignEmailId] = useState();
    const [assignBlocked, setAssignBlocked] = useState();
    const [searchKey, setSearchKey] = useState('');
    const [searchValue, setSearchValue] = useState('');

    // Apply filters when searchKey or searchValue changes
        useEffect(() => {
            if (searchKey && searchValue) {
                const filtered = allRows.filter((row) =>
                    row[searchKey]?.toString().toLowerCase().includes(searchValue.toLowerCase())
                );
                setFilteredRows(filtered);
                // setCurrentPage(1); // reset to first page when filtering
            } else {
                setFilteredRows(allRows); // show all if filter is empty
            }
            // console.log('All rows', allRows)
        }, [searchKey, searchValue, allRows]);

    const handleCreateRoles = () => {
        const userID = window.sessionStorage.getItem('userId');
        const JWTtoken = window.sessionStorage.getItem('token')
        if (newRole === '') {
            toast.error('Enter Role, New Role is empty!');
        } else {
            apiService.createNewRole(JWTtoken, userID, newRole)
                .then(response => {
                    if (response.data.message === 'Role already present') {
                        toast.error('Role already present')
                    } else {
                        toast.success('New Role Created');
                    }
                })
                .catch(error => {
                    setError(error);
                });
        }
    };

    const filteredUserData = userData.filter(item =>
        item.userId.toLowerCase().includes(searchEmpId.toLowerCase())
    );

    const handleSelectUserId = (userid, userName, emailId, blocked) => {
        setSearchEmpId(userid);
        setAssignUserId(userid)
        setAssignUserName(userName);
        setAssignEmailId(emailId);
        setAssignBlocked(blocked);
        setShowDropdown1(false);
    };

   
    const filteredRoleData = roles.filter(item =>
        item.role.toLowerCase().includes(searchRole.toLowerCase())
    );

    const handleSelectRole = (roledefined) => {
        // setRolesData(roledefined);
        setSearchRole(roledefined.toUpperCase())
        setShowDropdown2(false);
    };

    const handleGrantAccess = async () => {
        const JWTtoken = window.sessionStorage.getItem('token')
        const loginId = window.sessionStorage.getItem('userId')
        if (searchEmpId == '') {
            toast.error('Please Select Employee ID');
        } else if (searchRole == '') {
            toast.error('Please Select Employee Role', { delay: 1000 });
        } else {
            await apiService.createUserdataAndGrantAccess(JWTtoken, loginId , assignUserId, assignUserName, assignEmailId, assignBlocked, searchRole,
                searchTeamleader, searchBranchHead, searchExportCompliance, searchRegionBusinessHead, searchCreditInsurance, searchBusinessFinance
            )
                .then(response => {
                    if (response.data.message === 'Selected User Access Modified') {
                        toast.success('Selected User Access Modified')
                    } else {
                        toast.success('Access Granted');
                    }
                })
                .catch(error => {
                    setError(error);
                });
            setSearchEmpId('')
            setSearchRole('')
            setSearchTeamleader('')
            setSearchBranchHead('')
            setSearchExportCompliance('')
            setSearchRegionBusinessHead('')
            setSearchCreditInsurance('')
            setSearchBusinessFinance('')
            // setTimeout(toggleOpen, 1000);
        }


    };

    const loadcrmdata = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true); // Set loading to true before the request
        try {
            const JWTtoken = window.sessionStorage.getItem('token')
            await apiService.requestedFetchingCRM(JWTtoken)
                .then(response => {
                    console.log(':::::CRM DATA ARRIVED::::::::', response.data);
                })
        } catch (error) {
            setError(error.response ? error.response.data.error : 'An error occurred');
            // console.error('Error:', error);
        }
        finally {
            setLoading(false); // Set loading to false after the request is complete
        }
    };

// await apiService.updateUserFormAccess(JWTtoken, userId, fieldName, newValue).then(response => {
    const handleSwitchChange = async (userId, userName, fieldName, newValue) => {
    try {
        const JWTtoken = window.sessionStorage.getItem('token')
        const loginID =  window.sessionStorage.getItem('userId')
        await apiService.updateUserFormAccess(JWTtoken, loginID, userId, fieldName, newValue).then(response => {
                    console.log(':::::User Acess Updated::::::::', response.data);
                    toast.success(`${userName} San Access Modified for ${fieldName} to ${newValue}`)
                })
        await apiService.getAllUserWithRoles(JWTtoken)
            .then(response => {
                setAllRows(response.data.users);
            })
            .catch(error => {
                setError(error);
            });
    } catch (error) {
        console.error(`Failed to update ${fieldName} for ${userId}`, error);
    }
    };

    if (loading) return <h1>Fetching CRM DATA...</h1>;
    if (error) return <h1>Error: {error.message}</h1>;

    return (
        <>
            <Navbar />
            {/* <h1 className='headerRibbon'>Admin Panel</h1>
            <Container className="pt-3 mb-4">
                <Row className="justify-content-between">
                    <Col md="auto">
                        <img src={logo} className="w-100 shadow-4" style={{ maxWidth: '150px', height: 'auto' }} alt="login_banner_image" />
                    </Col>
                    <Col md="auto">
                        <Button variant="danger" onClick={() => navigate('/Logout')}>Logout</Button>
                    </Col>
                </Row>
            </Container> */}
            <Container className="pt-5 mb-4">
                <Row className="justify-content-between" md="12" style={{ display: "flex", border: "5px solid lightgrey", borderRadius: "20px" }}>
                    <Col md="auto">
                        <div style={{ padding: '20px' }}>
                            {/* Search Section */}
                            <Form className="d-flex gap-3">
                                <Form.Group controlId="searchKey">
                                    {/* <Form.Label>Search Field</Form.Label> */}
                                    <Form.Control
                                        as="select"
                                        value={searchKey}
                                        onChange={(e) => setSearchKey(e.target.value)}
                                    >
                                        <option value="">-- Select Field --</option>
                                        <option value="userId">Employee ID</option>
                                        <option value="userName">Employee Name</option>
                                        <option value="role">Employee Role</option>
                                        <option value="blocked">Blocked</option>
                                        <option value="deviceType">Device</option>
                                        {/* <option value="userId">Created By</option> */}
                                        {/* Add more keys as needed */}
                                    </Form.Control>
                                </Form.Group>

                                <Form.Group controlId="searchValue">
                                    {/* <Form.Label>Search Value</Form.Label> */}
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter search value"
                                        value={searchValue}
                                        onChange={(e) => setSearchValue(e.target.value)}
                                    />
                                </Form.Group>
                            </Form>
                        </div>
                    </Col>
                    {/* <Col md="auto">
                        <Button variant="success" onClick={loadcrmdata}>Load CRM</Button>
                    </Col> */}
                    <Col md='4' className='d-flex'>
                        <Col>
                            <InputGroup className="mb-3" style={{ padding: '20px' }}>
                                <Form.Control placeholder="Create Roles" value={newRole} onChange={(e) => setNewRole(e.target.value)}
                                />
                                <Button variant="success" onClick={handleCreateRoles}>Create Access</Button>
                            </InputGroup>
                        </Col>
                    </Col>
                    <Col md="auto" >
                        <div style={{ padding: '20px' }}>
                            <Button variant="success" onClick={toggleOpen}>Grant Access</Button>
                        </div>
                    </Col>
                </Row>
            </Container>
            <MDBContainer>

                <div style={styles.tableWrapper}>
                    <MDBTable align='middle' hover>
                        <MDBTableHead className='table-dark sticky-header'>
                            <tr>
                                <th scope='col'></th>
                                <th scope='col'>Employee ID</th>
                                <th scope='col'>Employee Name</th>
                                <th scope='col'>Employee Email</th>
                                <th scope='col'>Role Assigned</th>
                                <th scope='col'>Blocked</th>
                                <th scope='col'>Preloading</th>
                                <th scope='col'>CostSheet Corp</th>
                                <th scope='col'>CostSheet Gov</th>
                                <th scope='col'>RE-Approval</th>
                                <th scope='col'>Device</th>
                            </tr>
                        </MDBTableHead>
                        <MDBTableBody>
                            {/* {[...filteredRows]
                            .sort((a, b) => a.id - b.id)
                            .map((row, index) => ( */}
                            {currentRows.map((row, index) => (
                                <tr key={index}>
                                    <th scope='row'></th>
                                    <td>
                                        <p className='text-muted mb-0'>{row.userId}</p>
                                    </td>
                                    <td>
                                        <p className='text-muted mb-0'>{row.userName}</p>
                                    </td>
                                    <td>
                                        <p className='text-muted mb-0'>{row.emailId}</p>
                                    </td>
                                    <td>
                                        <MDBBadge pill>{row.role.toUpperCase()}</MDBBadge>
                                    </td>
                                    <td>
                                       <Form.Check
                                        key={row.userId} 
                                        type="switch"
                                        id={`switch-${row.userId}-blocked`}
                                        checked={row.blocked}
                                        onChange={() => handleSwitchChange(row.userId, row.userName, 'blocked', !row.blocked)}
                                        />
                                    </td>
                                    <td>
                                        <Form.Check 
                                            type="switch"
                                            id={`switch-${row.userId}-preloadingForm`}
                                            checked={row.form1}
                                            onChange={() => handleSwitchChange(row.userId, row.userName, 'form1', !row.form1)}
                                        />
                                    </td>

                                    <td>
                                        <Form.Check 
                                            type="switch"
                                            id={`switch-${row.userId}-costSheetCorp`}
                                            checked={row.form2}
                                            onChange={() => handleSwitchChange(row.userId, row.userName, 'form2', !row.form2)}
                                        />
                                    </td>

                                    <td>
                                        <Form.Check 
                                            type="switch"
                                            id={`switch-${row.userId}-costSheetGov`}
                                            checked={row.form3}
                                            onChange={() => handleSwitchChange(row.userId, row.userName, 'form3', !row.form3)}
                                        />
                                    </td>

                                    <td>
                                        <Form.Check 
                                            type="switch"
                                            id={`switch-${row.userId}-reApproval`}
                                            checked={row.form4}
                                            onChange={() => handleSwitchChange(row.userId, row.userName, 'form4', !row.form4)}
                                        />
                                    </td>
                                    <td>
                                        <p className='text-muted mb-0'>{row.deviceType}</p>
                                    </td>
                                </tr>
                            ))}
                        </MDBTableBody>
                    </MDBTable>
                </div>
                
                <div style={styles.pagination}>
            <button
                style={styles.pageButton}
                disabled={currentPage === 1}
                onClick={() => handlePageChange(currentPage - 1)}
            >
                Previous
            </button>

            {startPage > 1 && (
                <>
                    <button style={styles.pageButton} onClick={() => handlePageChange(1)}>1</button>
                    <span style={styles.ellipsis}>...</span>
                </>
            )}

            {[...Array(endPage - startPage + 1).keys()].map((index) => {
                const pageNum = startPage + index;
                return (
                    <button
                        key={pageNum}
                        style={{
                            ...styles.pageButton,
                            ...(pageNum === currentPage ? styles.activePageButton : {}),
                        }}
                        onClick={() => handlePageChange(pageNum)}
                    >
                        {pageNum}
                    </button>
                );
            })}

            {endPage < totalPages && (
                <>
                    <span style={styles.ellipsis}>...</span>
                    <button style={styles.pageButton} onClick={() => handlePageChange(totalPages)}>{totalPages}</button>
                </>
            )}

            <button
                style={styles.pageButton}
                disabled={currentPage === totalPages}
                onClick={() => handlePageChange(currentPage + 1)}
            >
                Next
            </button>
        </div>
            </MDBContainer>
            <MDBModal tabIndex='-1' open={centredModal} onClose={() => setCentredModal(false)}>
                <MDBModalDialog size="lg" centered>
                    <MDBModalContent style={{height: '300px'}}>
                        <MDBModalHeader>
                            <MDBModalTitle>Define User Role</MDBModalTitle>
                        </MDBModalHeader>
                        <MDBModalBody>
                            <Row className="mb-2">
                                {/* <Col md="5" className="customformlabel"><Form.Label>Employee ID</Form.Label></Col> */}
                                <Col className="searchable-select-container">
                                    <input type="text" placeholder="Select Employee ID" value={searchEmpId} onFocus={() => setShowDropdown1(true)} onBlur={() => setShowDropdown1(false)}
                                        onChange={(e) => { setSearchEmpId(e.target.value); setShowDropdown1(true); }} className="searchable-select-input"
                                    />
                                    {showDropdown1 && (
                                        <div className="searchable-select-dropdown">
                                            {filteredUserData.length > 0 ? (
                                                filteredUserData.map(item => (
                                                    <div key={item.userId} value={item.userId} className="searchable-select-item"
                                                        onMouseDown={() => handleSelectUserId(item.userId, item.userName, item.emailId, item.blocked)}>
                                                        {item.userId} - {item.userName}
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="searchable-select-item disabled">No results found</div>
                                            )}
                                        </div>
                                    )}
                                </Col>
                                {/* </Row>
                            <Row className="mb-2"> */}
                                {/* <Col md="5" className="customformlabel"><Form.Label>Role</Form.Label></Col> */}
                                <Col className="searchable-select-container">
                                    <input type="text" placeholder="Select Employee Role" value={searchRole} onFocus={() => setShowDropdown2(true)} onBlur={() => setShowDropdown2(false)}
                                        onChange={(e) => { setSearchRole(e.target.value.toUpperCase()); setShowDropdown2(true); }} className="searchable-select-input"
                                    />
                                    {showDropdown2 && (
                                        <div className="searchable-select-dropdown">
                                            {filteredRoleData.length > 0 ? (
                                                filteredRoleData.map(item => (
                                                    <div key={item.role} value={item.role} onMouseDown={() => handleSelectRole(item.role)} className="searchable-select-item">
                                                        {item.role.toUpperCase()}
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="searchable-select-item disabled">No results found</div>
                                            )}
                                        </div>
                                    )}
                                </Col>
                            </Row>
                            {/* <Row className="mb-2">
                                <Col className="searchable-select-container">
                                    <input type="text" placeholder="Select Team Leader" value={searchTeamleader} onFocus={() => setShowDropdown3(true)} onBlur={() => setShowDropdown3(false)}
                                        onChange={(e) => { setSearchTeamleader(e.target.value); setShowDropdown3(true); }} className="searchable-select-input"
                                    />
                                    {showDropdown3 && (
                                        <div className="searchable-select-dropdown">
                                            {filteredteamleader.length > 0 ? (
                                                filteredteamleader.map(item => (
                                                    <div key={item.userId} value={item.userId} className="searchable-select-item"
                                                        onMouseDown={() => handleSelectTeamLeader(item.userId)}>
                                                        {item.userId} - {item.userName}
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="searchable-select-item disabled">No results found</div>
                                            )}
                                        </div>
                                    )}
                                </Col>
                                <Col className="searchable-select-container">
                                    <input type="text" placeholder="Select Branch Head" value={searchBranchHead} onFocus={() => setShowDropdown4(true)} onBlur={() => setShowDropdown4(false)}
                                        onChange={(e) => { setSearchBranchHead(e.target.value); setShowDropdown4(true); }} className="searchable-select-input"
                                    />
                                    {showDropdown4 && (
                                        <div className="searchable-select-dropdown">
                                            {filteredBranchhead.length > 0 ? (
                                                filteredBranchhead.map(item => (
                                                    <div key={item.userId} value={item.userId} className="searchable-select-item"
                                                        onMouseDown={() => handleSelectBranchHead(item.userId)}>
                                                        {item.userId} - {item.userName}
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="searchable-select-item disabled">No results found</div>
                                            )}
                                        </div>
                                    )}
                                </Col>
                            </Row>
                            <Row className="mb-2">
                                <Col className="searchable-select-container">
                                    <input type="text" placeholder="Select Export Compliance" value={searchExportCompliance} onFocus={() => setShowDropdown5(true)} onBlur={() => setShowDropdown5(false)}
                                        onChange={(e) => { setSearchExportCompliance(e.target.value); setShowDropdown5(true); }} className="searchable-select-input"
                                    />
                                    {showDropdown5 && (
                                        <div className="searchable-select-dropdown">
                                            {filteredexportcompliance.length > 0 ? (
                                                filteredexportcompliance.map(item => (
                                                    <div key={item.userId} value={item.userId} className="searchable-select-item"
                                                        onMouseDown={() => handleSelectExportCompliance(item.userId)}>
                                                        {item.userId} - {item.userName}
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="searchable-select-item disabled">No results found</div>
                                            )}
                                        </div>
                                    )}
                                </Col>
                                <Col className="searchable-select-container">
                                    <input type="text" placeholder="Select Region Business Head" value={searchRegionBusinessHead} onFocus={() => setShowDropdown6(true)} onBlur={() => setShowDropdown6(false)}
                                        onChange={(e) => { setSearchRegionBusinessHead(e.target.value); setShowDropdown6(true); }} className="searchable-select-input"
                                    />
                                    {showDropdown6 && (
                                        <div className="searchable-select-dropdown">
                                            {filteredregionbusinesshead.length > 0 ? (
                                                filteredregionbusinesshead.map(item => (
                                                    <div key={item.userId} value={item.userId} className="searchable-select-item"
                                                        onMouseDown={() => handleSelectRegionBusinessHead(item.userId)}>
                                                        {item.userId} - {item.userName}
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="searchable-select-item disabled">No results found</div>
                                            )}
                                        </div>
                                    )}
                                </Col>
                            </Row> */}
                            {/* <Row className="mb-2">
                                <Col className="searchable-select-container">
                                    <input type="text" placeholder="Select Credit Insurance" value={searchCreditInsurance} onFocus={() => setShowDropdown7(true)} onBlur={() => setShowDropdown7(false)}
                                        onChange={(e) => { setSearchCreditInsurance(e.target.value); setShowDropdown7(true); }} className="searchable-select-input"
                                    />
                                    {showDropdown7 && (
                                        <div className="searchable-select-dropdown">
                                            {filteredcreditinsurance.length > 0 ? (
                                                filteredcreditinsurance.map(item => (
                                                    <div key={item.userId} value={item.userId} className="searchable-select-item"
                                                        onMouseDown={() => handleSelectCreditInsurance(item.userId)}>
                                                        {item.userId} - {item.userName}
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="searchable-select-item disabled">No results found</div>
                                            )}
                                        </div>
                                    )}
                                </Col>
                                <Col className="searchable-select-container">
                                    <input type="text" placeholder="Select Business Finance" value={searchBusinessFinance} onFocus={() => setShowDropdown8(true)} onBlur={() => setShowDropdown8(false)}
                                        onChange={(e) => { setSearchBusinessFinance(e.target.value); setShowDropdown8(true); }} className="searchable-select-input"
                                    />
                                    {showDropdown8 && (
                                        <div className="searchable-select-dropdown">
                                            {filteredbusinessfinance.length > 0 ? (
                                                filteredbusinessfinance.map(item => (
                                                    <div key={item.userId} value={item.userId} className="searchable-select-item"
                                                        onMouseDown={() => handleSelectBusinessFinance(item.userId)}>
                                                        {item.userId} - {item.userName}
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="searchable-select-item disabled">No results found</div>
                                            )}
                                        </div>
                                    )}
                                </Col>
                            </Row> */}
                            {/* <Row className="mb-2">
                                <Col className="searchable-select-container">
                                    <input type="text" placeholder="Select Credit Insurance" value={searchExportCompliance} onFocus={() => setShowDropdown9(true)} onBlur={() => setShowDropdown9(false)}
                                        onChange={(e) => { setSearchCreditInsurance(e.target.value); setShowDropdown7(true); }} className="searchable-select-input"
                                    />
                                    {showDropdown9 && (
                                        <div className="searchable-select-dropdown">
                                            {filteredUserData.length > 0 ? (
                                                filteredUserData.map(item => (
                                                    <div key={item.userId} value={item.userId} className="searchable-select-item"
                                                    onMouseDown={() => handleSelectCFO(item.userId)}>
                                                        {item.userId} - {item.userName}
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="searchable-select-item disabled">No results found</div>
                                            )}
                                        </div>
                                    )}
                                </Col>
                                <Col className="searchable-select-container">
                                    <input type="text" placeholder="Select Business Finance" value={searchRegionBusinessHead} onFocus={() => setShowDropdown8(true)} onBlur={() => setShowDropdown8(false)}
                                        onChange={(e) => { setSearchBusinessFinance(e.target.value); setShowDropdown8(true); }} className="searchable-select-input"
                                    />
                                    {showDropdown8 && (
                                        <div className="searchable-select-dropdown">
                                            {filteredUserData.length > 0 ? (
                                                filteredUserData.map(item => (
                                                    <div key={item.userId} value={item.userId} className="searchable-select-item"
                                                    onMouseDown={() => handleSelectCOO(item.userId)}>
                                                        {item.userId} - {item.userName}
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="searchable-select-item disabled">No results found</div>
                                            )}
                                        </div>
                                    )}
                                </Col>
                            </Row>
                            <Row className="mb-2">
                                <Col className="searchable-select-container">
                                    <input type="text" placeholder="Select CEO" value={searchCEO} onFocus={() => setShowDropdown11(true)} onBlur={() => setShowDropdown11(false)}
                                        onChange={(e) => { setSearchCEO(e.target.value); setShowDropdown11(true); }} className="searchable-select-input"
                                    />
                                    {showDropdown11 && (
                                        <div className="searchable-select-dropdown">
                                            {filteredUserData.length > 0 ? (
                                                filteredUserData.map(item => (
                                                    <div key={item.userId} value={item.userId} className="searchable-select-item"
                                                    onMouseDown={() => handleSelectCEO(item.userId)}>
                                                        {item.userId} - {item.userName}
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="searchable-select-item disabled">No results found</div>
                                            )}
                                        </div>
                                    )}
                                </Col>
                                <Col className="searchable-select-container">
                                    <input type="text" placeholder="Select SVP-Director" value={searchSvpDirector} onFocus={() => setShowDropdown12(true)} onBlur={() => setShowDropdown12(false)}
                                        onChange={(e) => { setSearchSvpDirector(e.target.value); setShowDropdown12(true); }} className="searchable-select-input"
                                    />
                                    {showDropdown12 && (
                                        <div className="searchable-select-dropdown">
                                            {filteredUserData.length > 0 ? (
                                                filteredUserData.map(item => (
                                                    <div key={item.userId} value={item.userId} className="searchable-select-item"
                                                    onMouseDown={() => handleSelectSvpDirector(item.userId)}>
                                                        {item.userId} - {item.userName}
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="searchable-select-item disabled">No results found</div>
                                            )}
                                        </div>
                                    )}
                                </Col>
                            </Row> */}

                        </MDBModalBody>
                        <MDBModalFooter>
                            <MDBBtn onClick={handleGrantAccess}>Grant</MDBBtn>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>

        </>
    )
}



const styles = {
        tableWrapper: {
            maxWidth: '100%',
            overflowX: 'auto', // Enable horizontal scrolling
            overflowY: 'auto', // Enable vertical scrolling
            maxHeight: '400px', // Adjust the height to fit your needs
            marginBottom: '15px',
        },
        pagination: {
            display: 'flex',
            justifyContent: 'center',
            gap: '5px',
            flexWrap: 'wrap',
            marginTop: '1rem',
        },
        pageButton: {
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            padding: '5px 10px',
            cursor: 'pointer',
            outline: 'none',
        },
        activePageButton: {
            backgroundColor: '#0056b3',
        },
        ellipsis: {
            padding: '5px 10px',
            color: '#555',
        },
    };


export default Admin





























// import { useState, useEffect } from 'react';
// import '../../index.css';
// import apiService from '../../services/api.services';
// import Navbar from '../../components/common/Navbar';
// import '../../css/adminpage.css';
// import { Row, Col, Container, Button, Form, InputGroup } from 'react-bootstrap';
// import { MDBTable, MDBTableHead, MDBTableBody, MDBBadge, MDBContainer, MDBBtn } from 'mdb-react-ui-kit';
// import { MDBModal, MDBModalDialog, MDBModalContent, MDBModalHeader, MDBModalTitle, MDBModalBody, MDBModalFooter } from 'mdb-react-ui-kit';
// import { toast } from 'react-toastify';


// function Admin() {

//     useEffect(() => {
//         const JWTtoken = window.sessionStorage.getItem('token')
//         apiService.getAllUserWithRoles(JWTtoken)
//             .then(response => {
//                 setAllRows(response.data.users);
//             })
//             .catch(error => {
//                 setError(error);
//             });
//         apiService.getAllUser(JWTtoken)
//             .then(response => {
//                 setUserData(response.data.users);
//             })
//             .catch(error => {
//                 setError(error);
//             });
//         apiService.getAllRoles(JWTtoken)
//             .then(response => {
//                 // setRolesData(response.data.users);
//                 setRolesData(response.data.roles);
//             })
//             .catch(error => {
//                 setError(error);
//             });
//     }, []);

//     // Data
//     const [allRows, setAllRows] = useState([]);
//     const [error, setError] = useState(null);

//     // Pagination state
//     const [currentPage, setCurrentPage] = useState(1);
//     const rowsPerPage = 10; // Number of rows per page

//     // Calculate total pages
//     const totalPages = Math.ceil(allRows.length / rowsPerPage);

//     // Calculate the rows to display on the current page
//     const indexOfLastRow = currentPage * rowsPerPage;
//     const indexOfFirstRow = indexOfLastRow - rowsPerPage;
//     const currentRows = allRows.slice(indexOfFirstRow, indexOfLastRow);

//     const pageGroupSize = 5;
//     const currentGroup = Math.floor((currentPage - 1) / pageGroupSize);
//     const startPage = currentGroup * pageGroupSize + 1;
//     const endPage = Math.min(startPage + pageGroupSize - 1, totalPages);

//     // Handle page change
//     const handlePageChange = (pageNumber) => {
//         setCurrentPage(pageNumber);
//     };

//     //----------------------------------------------------------------------- 

//     const [centredModal, setCentredModal] = useState(false);
//     const toggleOpen = () => setCentredModal(!centredModal);
//     const [userData, setUserData] = useState([]);
//     const [searchEmpId, setSearchEmpId] = useState('');
//     const [showDropdown1, setShowDropdown1] = useState(false);

//     const [searchTeamleader, setSearchTeamleader] = useState('');
//     const [showDropdown3, setShowDropdown3] = useState(false);

//     const [searchBranchHead, setSearchBranchHead] = useState('');
//     const [showDropdown4, setShowDropdown4] = useState(false);

//     const [searchExportCompliance, setSearchExportCompliance] = useState('');
//     const [showDropdown5, setShowDropdown5] = useState(false);

//     const [searchRegionBusinessHead, setSearchRegionBusinessHead] = useState('');
//     const [showDropdown6, setShowDropdown6] = useState(false);

//     const [searchCreditInsurance, setSearchCreditInsurance] = useState('');
//     const [showDropdown7, setShowDropdown7] = useState(false);

//     const [searchBusinessFinance, setSearchBusinessFinance] = useState('');
//     const [showDropdown8, setShowDropdown8] = useState(false);

//     // const [searchCFO, setSearchCFO] = useState('');
//     // const [showDropdown9, setShowDropdown9] = useState(false);

//     // const [searchCOO, setSearchCOO] = useState('');
//     // const [showDropdown10, setShowDropdown10] = useState(false);

//     // const [searchCEO, setSearchCEO] = useState('');
//     // const [showDropdown11, setShowDropdown11] = useState(false);

//     // const [searchSvpDirector, setSearchSvpDirector] = useState('');
//     // const [showDropdown12, setShowDropdown12] = useState(false);





//     const [roles, setRolesData] = useState([]);
//     const [searchRole, setSearchRole] = useState('');
//     const [showDropdown2, setShowDropdown2] = useState(false);
//     const [loading, setLoading] = useState(false);
//     const [newRole, setNewRole] = useState('');
//     const [assignUserId, setAssignUserId] = useState();
//     const [assignUserName, setAssignUserName] = useState();
//     const [assignEmailId, setAssignEmailId] = useState();
//     const [assignBlocked, setAssignBlocked] = useState();

//     const handleCreateRoles = () => {
//         const userID = window.sessionStorage.getItem('userId');
//         const JWTtoken = window.sessionStorage.getItem('token')
//         if (newRole == '') {
//             toast.error('Enter Role, New Role is empty!');
//         } else {
//             apiService.createNewRole(JWTtoken, userID, newRole)
//                 .then(response => {
//                     if (response.data.message === 'Role already present') {
//                         toast.error('Role already present')
//                     } else {
//                         toast.success('New Role Created');
//                     }
//                 })
//                 .catch(error => {
//                     setError(error);
//                 });
//         }
//     };

//     const filteredUserData = userData.filter(item =>
//         item.userId.toLowerCase().includes(searchEmpId.toLowerCase())
//     );


//     const handleSelectUserId = (userid, userName, emailId, blocked) => {
//         setSearchEmpId(userid);
//         setAssignUserId(userid)
//         setAssignUserName(userName);
//         setAssignEmailId(emailId);
//         setAssignBlocked(blocked);
//         setShowDropdown1(false);
//     };

//     const filteredRoleData = roles.filter(item =>
//         item.role.toLowerCase().includes(searchRole.toLowerCase())
//     );

//     const handleSelectRole = (roledefined) => {
//         // setRolesData(roledefined);
//         setSearchRole(roledefined.toUpperCase())
//         setShowDropdown2(false);
//     };

//     const handleGrantAccess = async () => {
//         const loginId = window.sessionStorage.getItem('userId')
//         const JWTtoken = window.sessionStorage.getItem('token')
//         if (searchEmpId == '') {
//             toast.error('Please Select Employee ID');
//         } else if (searchRole == '') {
//             toast.error('Please Select Employee Role', { delay: 1000 });
//         } else {
//             await apiService.createUserdataAndGrantAccess(JWTtoken, loginId , assignUserId, assignUserName, assignEmailId, assignBlocked, searchRole,
//                 searchTeamleader, searchBranchHead, searchExportCompliance, searchRegionBusinessHead, searchCreditInsurance, searchBusinessFinance
//             )
//                 .then(response => {
//                     if (response.data.message === 'Selected User Access Modified') {
//                         toast.success('Selected User Access Modified')
//                     } else {
//                         toast.success('Access Granted');
//                     }
//                 })
//                 .catch(error => {
//                     setError(error);
//                 });
//             setSearchEmpId('')
//             setSearchRole('')
//             setSearchTeamleader('')
//             setSearchBranchHead('')
//             setSearchExportCompliance('')
//             setSearchRegionBusinessHead('')
//             setSearchCreditInsurance('')
//             setSearchBusinessFinance('')
//             // setTimeout(toggleOpen, 1000);
//         }


//     };

//     const loadcrmdata = async (e) => {
//         e.preventDefault();
//         setError(null);
//         setLoading(true); // Set loading to true before the request
//         try {
//             const JWTtoken = window.sessionStorage.getItem('token')
//             await apiService.requestedFetchingCRM(JWTtoken)
//                 .then(response => {
//                     console.log(':::::CRM DATA ARRIVED::::::::', response.data);
//                 })
//         } catch (error) {
//             setError(error.response ? error.response.data.error : 'An error occurred');
//             // console.error('Error:', error);
//         }
//         finally {
//             setLoading(false); // Set loading to false after the request is complete
//         }
//     };


//     const handleSwitchChange = async (userId, userName, fieldName, newValue) => {
//     try {
//         const JWTtoken = window.sessionStorage.getItem('token')
//         const loginID =  window.sessionStorage.getItem('userId')
//         await apiService.updateUserFormAccess(JWTtoken, loginID, userId, fieldName, newValue).then(response => {
//                     console.log(':::::User Acess Updated::::::::', response.data);
//                     toast.success(`${userName} San Access Modified for ${fieldName} to ${newValue}`)
//                 })
//         await apiService.getAllUserWithRoles(JWTtoken)
//             .then(response => {
//                 setAllRows(response.data.users);
//             })
//             .catch(error => {
//                 setError(error);
//             });
//     } catch (error) {
//         console.error(`Failed to update ${fieldName} for ${userId}`, error);
//     }
//     };

//     if (loading) return <h1>Fetching CRM DATA...</h1>;
//     if (error) return <h1>Error: {error.message}</h1>;

//     return (
//         <>
//             <Navbar />
//             {/* <h1 className='headerRibbon'>Admin Panel</h1>
//             <Container className="pt-3 mb-4">
//                 <Row className="justify-content-between">
//                     <Col md="auto">
//                         <img src={logo} className="w-100 shadow-4" style={{ maxWidth: '150px', height: 'auto' }} alt="login_banner_image" />
//                     </Col>
//                     <Col md="auto">
//                         <Button variant="danger" onClick={() => navigate('/Logout')}>Logout</Button>
//                     </Col>
//                 </Row>
//             </Container> */}
//             <Container className="pt-5 mb-4">
//                 <Row className="justify-content-between">
//                     <Col md='4' className='d-flex'>
//                         <Col>
//                             <InputGroup className="mb-3">
//                                 <Form.Control placeholder="Create Roles" value={newRole} onChange={(e) => setNewRole(e.target.value)}
//                                 />
//                                 <Button variant="success" onClick={handleCreateRoles}>Create Access</Button>
//                             </InputGroup>
//                         </Col>
//                     </Col>
//                     <Col md="auto">
//                         <Button variant="success" onClick={loadcrmdata}>Load CRM</Button>
//                     </Col>
//                     <Col md="auto">
//                         <Button variant="success" onClick={toggleOpen}>Grant Access</Button>
//                     </Col>
//                 </Row>
//             </Container>
//             <MDBContainer>
//                 <div style={styles.tableWrapper}>
//                     <MDBTable align='middle' hover>
//                         <MDBTableHead className='table-dark sticky-header'>
//                             <tr>
//                                 <th scope='col'></th>
//                                 <th scope='col'>Employee ID</th>
//                                 <th scope='col'>Employee Name</th>
//                                 <th scope='col'>Employee Email</th>
//                                 <th scope='col'>Role Assigned</th>
//                                 <th scope='col'>Blocked</th>
//                                 <th scope='col'>Preloading</th>
//                                 <th scope='col'>CostSheet Corp</th>
//                                 <th scope='col'>CostSheet Gov</th>
//                                 <th scope='col'>RE-Approval</th>
//                                 <th scope='col'>Device</th>
//                             </tr>
//                         </MDBTableHead>
//                         <MDBTableBody>
//                             {currentRows.map((row, index) => (
//                                 <tr key={index}>
//                                     <th scope='row'></th>
//                                     <td>
//                                         <p className='text-muted mb-0'>{row.userId}</p>
//                                     </td>
//                                     <td>
//                                         <p className='text-muted mb-0'>{row.userName}</p>
//                                     </td>
//                                     <td>
//                                         <p className='text-muted mb-0'>{row.emailId}</p>
//                                     </td>
//                                     <td>
//                                         <MDBBadge pill>{row.role.toUpperCase()}</MDBBadge>
//                                     </td>
//                                     <td>
//                                        <Form.Check
//                                         key={row.userId} 
//                                         type="switch"
//                                         id={`switch-${row.userId}-blocked`}
//                                         checked={row.blocked}
//                                         onChange={() => handleSwitchChange(row.userId, row.userName, 'blocked', !row.blocked)}
//                                         />
//                                     </td>
//                                     <td>
//                                         <Form.Check 
//                                             type="switch"
//                                             id={`switch-${row.userId}-preloadingForm`}
//                                             checked={row.form1}
//                                             onChange={() => handleSwitchChange(row.userId, row.userName, 'form1', !row.form1)}
//                                         />
//                                     </td>

//                                     <td>
//                                         <Form.Check 
//                                             type="switch"
//                                             id={`switch-${row.userId}-costSheetCorp`}
//                                             checked={row.form2}
//                                             onChange={() => handleSwitchChange(row.userId, row.userName, 'form2', !row.form2)}
//                                         />
//                                     </td>

//                                     <td>
//                                         <Form.Check 
//                                             type="switch"
//                                             id={`switch-${row.userId}-costSheetGov`}
//                                             checked={row.form3}
//                                             onChange={() => handleSwitchChange(row.userId, row.userName, 'form3', !row.form3)}
//                                         />
//                                     </td>

//                                     <td>
//                                         <Form.Check 
//                                             type="switch"
//                                             id={`switch-${row.userId}-reApproval`}
//                                             checked={row.form4}
//                                             onChange={() => handleSwitchChange(row.userId, row.userName, 'form4', !row.form4)}
//                                         />
//                                     </td>
//                                     <td>
//                                         <p className='text-muted mb-0'>{row.deviceType}</p>
//                                     </td>
//                                 </tr>
//                             ))}
//                         </MDBTableBody>
//                     </MDBTable>
//                 </div>
//                 {/* Pagination Controls */}
//                 {/* <div style={styles.pagination}>
//                     <button
//                         style={styles.pageButton}
//                         disabled={currentPage === 1}
//                         onClick={() => handlePageChange(currentPage - 1)}
//                     >
//                         Previous
//                     </button>
//                     {[...Array(totalPages).keys()].map((number) => (
//                         <button
//                             key={number}
//                             style={{ ...styles.pageButton, ...(number + 1 === currentPage ? styles.activePageButton : {}) }}
//                             onClick={() => handlePageChange(number + 1)}
//                         >
//                             {number + 1}
//                         </button>
//                     ))}
//                     <button
//                         style={styles.pageButton}
//                         disabled={currentPage === totalPages}
//                         onClick={() => handlePageChange(currentPage + 1)}
//                     >
//                         Next
//                     </button>
//                 </div> */}

//                 <div style={styles.pagination}>
//             <button
//                 style={styles.pageButton}
//                 disabled={currentPage === 1}
//                 onClick={() => handlePageChange(currentPage - 1)}
//             >
//                 Previous
//             </button>

//             {startPage > 1 && (
//                 <>
//                     <button style={styles.pageButton} onClick={() => handlePageChange(1)}>1</button>
//                     <span style={styles.ellipsis}>...</span>
//                 </>
//             )}

//             {[...Array(endPage - startPage + 1).keys()].map((index) => {
//                 const pageNum = startPage + index;
//                 return (
//                     <button
//                         key={pageNum}
//                         style={{
//                             ...styles.pageButton,
//                             ...(pageNum === currentPage ? styles.activePageButton : {}),
//                         }}
//                         onClick={() => handlePageChange(pageNum)}
//                     >
//                         {pageNum}
//                     </button>
//                 );
//             })}

//             {endPage < totalPages && (
//                 <>
//                     <span style={styles.ellipsis}>...</span>
//                     <button style={styles.pageButton} onClick={() => handlePageChange(totalPages)}>{totalPages}</button>
//                 </>
//             )}

//             <button
//                 style={styles.pageButton}
//                 disabled={currentPage === totalPages}
//                 onClick={() => handlePageChange(currentPage + 1)}
//             >
//                 Next
//             </button>
//         </div>
//             </MDBContainer>
//             <MDBModal tabIndex='-1' open={centredModal} onClose={() => setCentredModal(false)}>
//                 <MDBModalDialog size="lg" centered>
//                     <MDBModalContent style={{height: '300px'}}>
//                         <MDBModalHeader>
//                             <MDBModalTitle>Define User Role</MDBModalTitle>
//                         </MDBModalHeader>
//                         <MDBModalBody>
//                             <Row className="mb-2">
//                                 {/* <Col md="5" className="customformlabel"><Form.Label>Employee ID</Form.Label></Col> */}
//                                 <Col className="searchable-select-container">
//                                     <input type="text" placeholder="Select Employee ID" value={searchEmpId} onFocus={() => setShowDropdown1(true)} onBlur={() => setShowDropdown1(false)}
//                                         onChange={(e) => { setSearchEmpId(e.target.value); setShowDropdown1(true); }} className="searchable-select-input"
//                                     />
//                                     {showDropdown1 && (
//                                         <div className="searchable-select-dropdown">
//                                             {filteredUserData.length > 0 ? (
//                                                 filteredUserData.map(item => (
//                                                     <div key={item.userId} value={item.userId} className="searchable-select-item"
//                                                         onMouseDown={() => handleSelectUserId(item.userId, item.userName, item.emailId, item.blocked)}>
//                                                         {item.userId} - {item.userName}
//                                                     </div>
//                                                 ))
//                                             ) : (
//                                                 <div className="searchable-select-item disabled">No results found</div>
//                                             )}
//                                         </div>
//                                     )}
//                                 </Col>
//                                 {/* </Row>
//                             <Row className="mb-2"> */}
//                                 {/* <Col md="5" className="customformlabel"><Form.Label>Role</Form.Label></Col> */}
//                                 <Col className="searchable-select-container">
//                                     <input type="text" placeholder="Select Employee Role" value={searchRole} onFocus={() => setShowDropdown2(true)} onBlur={() => setShowDropdown2(false)}
//                                         onChange={(e) => { setSearchRole(e.target.value.toUpperCase()); setShowDropdown2(true); }} className="searchable-select-input"
//                                     />
//                                     {showDropdown2 && (
//                                         <div className="searchable-select-dropdown">
//                                             {filteredRoleData.length > 0 ? (
//                                                 filteredRoleData.map(item => (
//                                                     <div key={item.role} value={item.role} onMouseDown={() => handleSelectRole(item.role)} className="searchable-select-item">
//                                                         {item.role.toUpperCase()}
//                                                     </div>
//                                                 ))
//                                             ) : (
//                                                 <div className="searchable-select-item disabled">No results found</div>
//                                             )}
//                                         </div>
//                                     )}
//                                 </Col>
//                             </Row>
//                             {/* <Row className="mb-2">
//                                 <Col className="searchable-select-container">
//                                     <input type="text" placeholder="Select Team Leader" value={searchTeamleader} onFocus={() => setShowDropdown3(true)} onBlur={() => setShowDropdown3(false)}
//                                         onChange={(e) => { setSearchTeamleader(e.target.value); setShowDropdown3(true); }} className="searchable-select-input"
//                                     />
//                                     {showDropdown3 && (
//                                         <div className="searchable-select-dropdown">
//                                             {filteredteamleader.length > 0 ? (
//                                                 filteredteamleader.map(item => (
//                                                     <div key={item.userId} value={item.userId} className="searchable-select-item"
//                                                         onMouseDown={() => handleSelectTeamLeader(item.userId)}>
//                                                         {item.userId} - {item.userName}
//                                                     </div>
//                                                 ))
//                                             ) : (
//                                                 <div className="searchable-select-item disabled">No results found</div>
//                                             )}
//                                         </div>
//                                     )}
//                                 </Col>
//                                 <Col className="searchable-select-container">
//                                     <input type="text" placeholder="Select Branch Head" value={searchBranchHead} onFocus={() => setShowDropdown4(true)} onBlur={() => setShowDropdown4(false)}
//                                         onChange={(e) => { setSearchBranchHead(e.target.value); setShowDropdown4(true); }} className="searchable-select-input"
//                                     />
//                                     {showDropdown4 && (
//                                         <div className="searchable-select-dropdown">
//                                             {filteredBranchhead.length > 0 ? (
//                                                 filteredBranchhead.map(item => (
//                                                     <div key={item.userId} value={item.userId} className="searchable-select-item"
//                                                         onMouseDown={() => handleSelectBranchHead(item.userId)}>
//                                                         {item.userId} - {item.userName}
//                                                     </div>
//                                                 ))
//                                             ) : (
//                                                 <div className="searchable-select-item disabled">No results found</div>
//                                             )}
//                                         </div>
//                                     )}
//                                 </Col>
//                             </Row>
//                             <Row className="mb-2">
//                                 <Col className="searchable-select-container">
//                                     <input type="text" placeholder="Select Export Compliance" value={searchExportCompliance} onFocus={() => setShowDropdown5(true)} onBlur={() => setShowDropdown5(false)}
//                                         onChange={(e) => { setSearchExportCompliance(e.target.value); setShowDropdown5(true); }} className="searchable-select-input"
//                                     />
//                                     {showDropdown5 && (
//                                         <div className="searchable-select-dropdown">
//                                             {filteredexportcompliance.length > 0 ? (
//                                                 filteredexportcompliance.map(item => (
//                                                     <div key={item.userId} value={item.userId} className="searchable-select-item"
//                                                         onMouseDown={() => handleSelectExportCompliance(item.userId)}>
//                                                         {item.userId} - {item.userName}
//                                                     </div>
//                                                 ))
//                                             ) : (
//                                                 <div className="searchable-select-item disabled">No results found</div>
//                                             )}
//                                         </div>
//                                     )}
//                                 </Col>
//                                 <Col className="searchable-select-container">
//                                     <input type="text" placeholder="Select Region Business Head" value={searchRegionBusinessHead} onFocus={() => setShowDropdown6(true)} onBlur={() => setShowDropdown6(false)}
//                                         onChange={(e) => { setSearchRegionBusinessHead(e.target.value); setShowDropdown6(true); }} className="searchable-select-input"
//                                     />
//                                     {showDropdown6 && (
//                                         <div className="searchable-select-dropdown">
//                                             {filteredregionbusinesshead.length > 0 ? (
//                                                 filteredregionbusinesshead.map(item => (
//                                                     <div key={item.userId} value={item.userId} className="searchable-select-item"
//                                                         onMouseDown={() => handleSelectRegionBusinessHead(item.userId)}>
//                                                         {item.userId} - {item.userName}
//                                                     </div>
//                                                 ))
//                                             ) : (
//                                                 <div className="searchable-select-item disabled">No results found</div>
//                                             )}
//                                         </div>
//                                     )}
//                                 </Col>
//                             </Row> */}
//                             {/* <Row className="mb-2">
//                                 <Col className="searchable-select-container">
//                                     <input type="text" placeholder="Select Credit Insurance" value={searchCreditInsurance} onFocus={() => setShowDropdown7(true)} onBlur={() => setShowDropdown7(false)}
//                                         onChange={(e) => { setSearchCreditInsurance(e.target.value); setShowDropdown7(true); }} className="searchable-select-input"
//                                     />
//                                     {showDropdown7 && (
//                                         <div className="searchable-select-dropdown">
//                                             {filteredcreditinsurance.length > 0 ? (
//                                                 filteredcreditinsurance.map(item => (
//                                                     <div key={item.userId} value={item.userId} className="searchable-select-item"
//                                                         onMouseDown={() => handleSelectCreditInsurance(item.userId)}>
//                                                         {item.userId} - {item.userName}
//                                                     </div>
//                                                 ))
//                                             ) : (
//                                                 <div className="searchable-select-item disabled">No results found</div>
//                                             )}
//                                         </div>
//                                     )}
//                                 </Col>
//                                 <Col className="searchable-select-container">
//                                     <input type="text" placeholder="Select Business Finance" value={searchBusinessFinance} onFocus={() => setShowDropdown8(true)} onBlur={() => setShowDropdown8(false)}
//                                         onChange={(e) => { setSearchBusinessFinance(e.target.value); setShowDropdown8(true); }} className="searchable-select-input"
//                                     />
//                                     {showDropdown8 && (
//                                         <div className="searchable-select-dropdown">
//                                             {filteredbusinessfinance.length > 0 ? (
//                                                 filteredbusinessfinance.map(item => (
//                                                     <div key={item.userId} value={item.userId} className="searchable-select-item"
//                                                         onMouseDown={() => handleSelectBusinessFinance(item.userId)}>
//                                                         {item.userId} - {item.userName}
//                                                     </div>
//                                                 ))
//                                             ) : (
//                                                 <div className="searchable-select-item disabled">No results found</div>
//                                             )}
//                                         </div>
//                                     )}
//                                 </Col>
//                             </Row> */}
//                             {/* <Row className="mb-2">
//                                 <Col className="searchable-select-container">
//                                     <input type="text" placeholder="Select Credit Insurance" value={searchExportCompliance} onFocus={() => setShowDropdown9(true)} onBlur={() => setShowDropdown9(false)}
//                                         onChange={(e) => { setSearchCreditInsurance(e.target.value); setShowDropdown7(true); }} className="searchable-select-input"
//                                     />
//                                     {showDropdown9 && (
//                                         <div className="searchable-select-dropdown">
//                                             {filteredUserData.length > 0 ? (
//                                                 filteredUserData.map(item => (
//                                                     <div key={item.userId} value={item.userId} className="searchable-select-item"
//                                                     onMouseDown={() => handleSelectCFO(item.userId)}>
//                                                         {item.userId} - {item.userName}
//                                                     </div>
//                                                 ))
//                                             ) : (
//                                                 <div className="searchable-select-item disabled">No results found</div>
//                                             )}
//                                         </div>
//                                     )}
//                                 </Col>
//                                 <Col className="searchable-select-container">
//                                     <input type="text" placeholder="Select Business Finance" value={searchRegionBusinessHead} onFocus={() => setShowDropdown8(true)} onBlur={() => setShowDropdown8(false)}
//                                         onChange={(e) => { setSearchBusinessFinance(e.target.value); setShowDropdown8(true); }} className="searchable-select-input"
//                                     />
//                                     {showDropdown8 && (
//                                         <div className="searchable-select-dropdown">
//                                             {filteredUserData.length > 0 ? (
//                                                 filteredUserData.map(item => (
//                                                     <div key={item.userId} value={item.userId} className="searchable-select-item"
//                                                     onMouseDown={() => handleSelectCOO(item.userId)}>
//                                                         {item.userId} - {item.userName}
//                                                     </div>
//                                                 ))
//                                             ) : (
//                                                 <div className="searchable-select-item disabled">No results found</div>
//                                             )}
//                                         </div>
//                                     )}
//                                 </Col>
//                             </Row>
//                             <Row className="mb-2">
//                                 <Col className="searchable-select-container">
//                                     <input type="text" placeholder="Select CEO" value={searchCEO} onFocus={() => setShowDropdown11(true)} onBlur={() => setShowDropdown11(false)}
//                                         onChange={(e) => { setSearchCEO(e.target.value); setShowDropdown11(true); }} className="searchable-select-input"
//                                     />
//                                     {showDropdown11 && (
//                                         <div className="searchable-select-dropdown">
//                                             {filteredUserData.length > 0 ? (
//                                                 filteredUserData.map(item => (
//                                                     <div key={item.userId} value={item.userId} className="searchable-select-item"
//                                                     onMouseDown={() => handleSelectCEO(item.userId)}>
//                                                         {item.userId} - {item.userName}
//                                                     </div>
//                                                 ))
//                                             ) : (
//                                                 <div className="searchable-select-item disabled">No results found</div>
//                                             )}
//                                         </div>
//                                     )}
//                                 </Col>
//                                 <Col className="searchable-select-container">
//                                     <input type="text" placeholder="Select SVP-Director" value={searchSvpDirector} onFocus={() => setShowDropdown12(true)} onBlur={() => setShowDropdown12(false)}
//                                         onChange={(e) => { setSearchSvpDirector(e.target.value); setShowDropdown12(true); }} className="searchable-select-input"
//                                     />
//                                     {showDropdown12 && (
//                                         <div className="searchable-select-dropdown">
//                                             {filteredUserData.length > 0 ? (
//                                                 filteredUserData.map(item => (
//                                                     <div key={item.userId} value={item.userId} className="searchable-select-item"
//                                                     onMouseDown={() => handleSelectSvpDirector(item.userId)}>
//                                                         {item.userId} - {item.userName}
//                                                     </div>
//                                                 ))
//                                             ) : (
//                                                 <div className="searchable-select-item disabled">No results found</div>
//                                             )}
//                                         </div>
//                                     )}
//                                 </Col>
//                             </Row> */}

//                         </MDBModalBody>
//                         <MDBModalFooter>
//                             <MDBBtn onClick={handleGrantAccess}>Grant</MDBBtn>
//                         </MDBModalFooter>
//                     </MDBModalContent>
//                 </MDBModalDialog>
//             </MDBModal>

//         </>
//     )
// }



// const styles = {
//         tableWrapper: {
//             maxWidth: '100%',
//             overflowX: 'auto', // Enable horizontal scrolling
//             overflowY: 'auto', // Enable vertical scrolling
//             maxHeight: '300px', // Adjust the height to fit your needs
//             marginBottom: '10px',
//         },
//         pagination: {
//             display: 'flex',
//             justifyContent: 'center',
//             gap: '5px',
//             flexWrap: 'wrap',
//             marginTop: '1rem',
//         },
//         pageButton: {
//             backgroundColor: '#007bff',
//             color: 'white',
//             border: 'none',
//             borderRadius: '4px',
//             padding: '5px 10px',
//             cursor: 'pointer',
//             outline: 'none',
//         },
//         activePageButton: {
//             backgroundColor: '#0056b3',
//         },
//         ellipsis: {
//             padding: '5px 10px',
//             color: '#555',
//         },
//     };


// export default Admin
